import { useState } from "react";

import { LanguageOptions } from "@/Administration/Models/UI/Enums/Administration";
import { ClickableTextItem } from "@/Common/Api/ClickableText/Dto/ClickableTextItem";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";

import styles from "./PopulationBasedFundingClickableText.module.scss";

class PopulationBasedFundingClickableTextProps {
    public user: EmployeeUIModel;
    public languageOption: LanguageOptions;
    public readonly?: boolean;

    public importDeleteSectionStyle?: React.CSSProperties;
    public importClickableTextStyle?: React.CSSProperties;
    public deleteClickableTextStyle?: React.CSSProperties;

    public onEditClickableText?: (item: ClickableTextItem) => void;
    public onAddNewClicakbleText?: (context: string) => void;
    public onImport?: (context: string) => void;
    public onDelete?: (context: string, label: string) => void;
}

function PopulationBasedFundingClickableText(props: PopulationBasedFundingClickableTextProps): JSX.Element {
    const context = "PBFNOTES";
    const textList = props.user.Model.TextList
        .sortByProperty(clickableTextItem => clickableTextItem.TabOrderIndex);

    const [lang] = useState<string>(sessionStore.getLanguageStringFromEnum(props.languageOption));

    const renderReadOnlyTextItemList = (): JSX.Element => {
        let notesR = "";
        const notesRecall: ClickableTextItem[] = (textList) ? props.user.getAggregatedTabNames(context, lang) : [];
        if (notesRecall) {
            notesR = notesRecall.map(note => note.TabName).join(", ");
        }
        return <strong>{MyleHelper.ReplaceEmptyString(notesR)}</strong>;
    };

    const renderClickableTextItemList = (): JSX.Element => {
        const uniqueArrayNotesRecall: ClickableTextItem[] = (textList) ? props.user.getAggregatedTabNames(context, lang) : [];
        return (
            <strong>
                {uniqueArrayNotesRecall?.length > 0 && uniqueArrayNotesRecall.map((clickableText: ClickableTextItem, index: number) => (
                    <a key={index + "_PBFNote"} onClick={() => props.onEditClickableText(clickableText)}>
                        {clickableText.TabName} {(index != uniqueArrayNotesRecall.length - 1) && " , "}
                    </a>
                ))}
                {uniqueArrayNotesRecall != null && uniqueArrayNotesRecall.length == 0 && "--"}
            </strong>
        );
    };

    return (
        <div className="psingle-column practice centered">
            <div className="tb">
                <div className="tbc">
                    <div>
                        <table>
                            <tbody>
                                <tr>
                                    <td className={`${styles.textContainer} c1`}>
                                        <label className="form-label">{cacheStore.GetString("NotesDLabel")}</label>
                                        {!props.readonly && (
                                            <a onClick={() => props.onAddNewClicakbleText(context)}>
                                                <strong>[+]</strong>
                                            </a>
                                        )}
                                    </td>

                                    <td className={`${styles.textContainer} c2`}>
                                        {props.readonly
                                            ? renderReadOnlyTextItemList()
                                            : renderClickableTextItemList()
                                        }
                                    </td>

                                    {!props.readonly && (
                                        <td style={props.importDeleteSectionStyle}>
                                            <a onClick={() => props.onImport(context)} style={props.importClickableTextStyle}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => props.onDelete(context, cacheStore.GetString("NotesDLabel"))} style={props.deleteClickableTextStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    )}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
export { PopulationBasedFundingClickableText };
